import { useQuery } from 'react-query';
import { useAxiosClient } from '../utils/useAxiosClient';

export interface ImageComparisonParams {
  brandId?: string;
  startDate?: string | null;
  endDate?: string | null;
  minEngagementScore?: number;
  minFeatureCount?: number;
  keyword?: string;
}

export const useImageComparisonData = (params: ImageComparisonParams) => {
  const axiosClient = useAxiosClient();
  
  const { brandId, startDate, endDate, minEngagementScore = 0, minFeatureCount = 0, keyword = '' } = params;
  
  const queryKey = ['imageComparisonData', brandId, startDate, endDate, minEngagementScore, minFeatureCount, keyword];
  
  const { data, isLoading, error } = useQuery(
    queryKey,
    async () => {
      // Construct query parameters
      const queryParams = new URLSearchParams();
      
      if (brandId) queryParams.append('brand_id', brandId);
      if (startDate) queryParams.append('start_date', startDate);
      if (endDate) queryParams.append('end_date', endDate);
      queryParams.append('min_engagement_score', minEngagementScore.toString());
      queryParams.append('min_feature_count', minFeatureCount.toString());
      if (keyword && keyword.trim() !== '') queryParams.append('keyword', keyword);
      
      const response = await axiosClient.get(`/api/get-image-comparison-data?${queryParams}`);
      return response.data;
    },
    {
      enabled: !!brandId && !!startDate && !!endDate,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false
    }
  );
  
  return {
    data,
    loading: isLoading,
    error: error ? (error instanceof Error ? error.message : 'An error occurred') : null
  };
}; 